import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import Lefbar from "./Lefbar";
import LoginPage from "../Login/LoginPage";
import Loader from "./Loader";
import { postDataWithoutToken } from "../store/utils";
import InventoryList from "../pages/Warehouse/InventoryList.js";
import BulkInventory from "../pages/Warehouse/BulkInventory.js";
import ImportedFile from "../pages/Warehouse/ImportedFile.js";
import WarehouseList from "../pages/Warehouse/WarehouseList.js";
import AddInventory from "../pages/Warehouse/AddInventory.js";
import OrdersList from "../pages/Orders/OrdersList.js";
import OrderDetails from "../pages/Orders/OrderDetails.js";
import OrderDashboard from "../pages/WarehouseOrder/OrderDashboard.js";
import WarehouseOrderList from "../pages/WarehouseOrder/WarehouseOrderList.jsx";
import WarehouseOrderDetail from "../pages/WarehouseOrder/WarehouseOrderDetail.jsx";

function Routes() {
  const [isAuthenticated, setIsAuthenticated] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
  const [isWarehouseUser, setIsWarehouseUser] = useState(null);

  useEffect(() => {
    const storedAuthState = localStorage.getItem("isAuthenticated");
    if (storedAuthState) {
      setIsAuthenticated(storedAuthState);
    }
    setIsLoading(false);
  }, [isAuthenticated]);

  useEffect(() => {
    const storeWarehouseUser = localStorage.getItem("isWarehouse");
  
  
    if (Number(storeWarehouseUser) == 1) {
      console.log("********************check*", );
      
      setIsWarehouseUser(true);
    }else{
      setIsWarehouseUser(false);
    }
  }, []);


  console.log(isWarehouseUser,"last final");
  const handleLogin = async (userId, password, history) => {
    let tempDocument = {
      email: userId,
      password: password,
      distributorId: 8603,
    };

    setIsLoading(true);
    const tempData = await postDataWithoutToken(`auth/distributorUserLogin`, tempDocument);
    setIsLoading(false);

    if (tempData?.data?.accessToken) {
      localStorage.setItem("isAuthenticated", tempData.data.accessToken);
      localStorage.setItem("jwtRefreshToken", tempData.data.refreshToken);
      localStorage.setItem("isWarehouse", tempData.data.isWarehouse);

      // **Update state to trigger re-render**
      setIsAuthenticated(tempData.data.accessToken);

      // Redirect programmatically
      if (tempData.data.isWarehouse == 1) {
        // Mobile device
        history.replace("/OrderDashboard");
      } else {
        // Desktop or tablet
        history.push("/");
      }
    } else {
      alert("Invalid username or password");
    }
  };


  const toggleSidebar = () => {
    setIsSidebarCollapsed((prevState) => !prevState);
  };

  const handleLogout = () => {
    setIsAuthenticated("");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("jwtRefreshToken");
    localStorage.removeItem("USER_ROLE");
    localStorage.removeItem("USER_DATA");
    localStorage.removeItem("isWarehouse");
    window.location.href = "/login";
  };

  const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        isLoading ? (
          <Loader />
        ) : isAuthenticated && isAuthenticated.length > 0 ? (
          <>
            <Component {...props} />
          </>
        ) : (
          <LoginPage handleLogin={handleLogin} />
        )
      }
    />
  );

  return (
    <Router>
      <div className="AppContainer">
        {isAuthenticated &&
          isAuthenticated !== undefined &&
          isAuthenticated.length > 0 && (
            <div
              className="asideMenuBarTab"
              // style={{ width: isSidebarCollapsed ? "70px" : "" }} 
              style={{ width: isSidebarCollapsed ? "" : "10%" }}
            >

              <Lefbar
                handleLogout={handleLogout}
                toggleSidebar={toggleSidebar}
                isSidebarCollapsed={isSidebarCollapsed}
              />
            </div>
          )}

        <main className="main-content">
          <Switch>
            <Route path="/login">
              {isAuthenticated &&
                isAuthenticated !== undefined &&
                isAuthenticated.length > 0 ? (
                isWarehouseUser ? (
                  <Redirect to="/OrderDashboard" />
                ) : (
                  <Redirect to="/" />
                )

              ) : (
                <LoginPage handleLogin={handleLogin} />
              )}
            </Route>
            {/* <Route path="/ForgetPassword"><ForgetPassword /></Route> */}
            <PrivateRoute path="/" exact component={WarehouseList} />
            <PrivateRoute path="/WarehouseList" component={WarehouseList} />
            <PrivateRoute path="/InventoryList" component={InventoryList} />
            <PrivateRoute path="/BulkInventory" component={BulkInventory} />
            <PrivateRoute path="/ImportedFile" component={ImportedFile} />
            <PrivateRoute path="/AddInventory" component={AddInventory} />
            <PrivateRoute path="/OrdersList" component={OrdersList} />
            <PrivateRoute path="/OrderDetails" component={OrderDetails} />
            <PrivateRoute path="/OrderDashboard" component={OrderDashboard} />
            <PrivateRoute path="/WarehouseOrderList/:statusId?" component={WarehouseOrderList} />
            <PrivateRoute path="/WarehouseOrderDetail/:id" component={WarehouseOrderDetail} />
          </Switch>
        </main>
      </div>
    </Router>
  );
}

export default Routes;
